import { format, parse } from 'date-fns';

/**
 * Formats a date
 * @param {string} [date] Date string to format
 * @param {string} inputFormat Format of date string
 * @param {string} outputFormat Desired output format
 * @returns {string} Formatted date
 */
export const formatDate = (date, inputFormat, outputFormat) => {
  try {
    return format(parse(date, inputFormat, new Date()), outputFormat);
  } catch (e) {
    return '';
  }
};
